webpackJsonp([48],{

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(130);

var $ = __webpack_require__(0);
var $document = $(document);

var DocumentList = function DocumentList(container) {
    _classCallCheck(this, DocumentList);

    this.$container = $(container);

    var $orderSelect = this.$container.find("[data-o-doc-list-order-values]");

    $orderSelect.change(function () {
        window.location.href = $orderSelect.val();
    });
};

var initModels = function initModels() {
    $("[data-o-doc-list]").each(function () {
        if (this.DocumentList) return;
        this.DocumentList = new DocumentList(this);
    });
};

var init = function init() {
    initModels();
};

init();

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[129]);


// WEBPACK FOOTER //
// o-doc-list.js